<script setup>
import moment from "moment";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="px-3 pb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Edit Profile
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="container p-4">
              <!-- form di sini -->
              <form action="#" @submit.prevent="preventSubmit">
                <div class="row mb-1">
                  <div class="col-md-12">
                    <p class="text-danger fst-italic fs-8 fw-bold">
                      * Wajib diisi
                    </p>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-7">
                    <label for="namaKontraktor" class="form-label fs-8 fw-bold"
                      >Nama Kontraktor
                      <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="namaKontraktor"
                      placeholder="Masukkan Nama Kontraktor"
                      v-model="formValues.namaKontraktor"
                    />
                  </div>
                  <div class="col-md-5">
                    <label for="fileLogo" class="form-label fs-8 fw-bold"
                      >Logo (png, jpg, jpeg)</label
                    >
                    <div class="input-group">
                      <input
                        type="file"
                        ref="fileLogo"
                        accept="image/*"
                        class="form-control fs-9"
                        id="inputGroupFile04"
                        aria-describedby="inputGroupFileAddon04"
                        aria-label="Upload"
                      />
                      <button
                        class="btn btn-outline-secondary fs-9 border border-start-0"
                        type="button"
                        id="inputGroupFileAddon04"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-cloud-arrow-up"
                          style="color: #000000"
                        />
                      </button>
                    </div>
                    <div v-if="kontraktor.image != null" class="fs-8">
                      File saat ini :
                      <a
                        class="text-danger pointer"
                        @click="downloadFile(kontraktor.image)"
                        >{{ kontraktor.image }}</a
                      >
                    </div>
                  </div>
                </div>
                <div class="row mb-1">
                  <div class="col-md-12">
                    <p
                      class="mb-1"
                      style="
                        font-family: 'Inter-Thin';
                        font-size: 0.9rem;
                        letter-spacing: 0.1rem;
                        font-weight: bold;
                      "
                    >
                      INFORMASI PJO
                    </p>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-4">
                    <label for="namaPjo" class="form-label fs-8 fw-bold"
                      >Nama PJO</label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="namaPjo"
                      placeholder="Masukkan Nama PJO"
                      v-model="formValues.namaPjo"
                    />
                  </div>
                  <div class="col-md-4">
                    <label for="namaPjo" class="form-label fs-8 fw-bold"
                      >Kompetensi PJO</label
                    >
                    <!--                                              <input
                                                                          type="text"
                                                                          class="form-control fs-9"
                                                                          id="namaPjo"
                                                                          placeholder="Masukkan Nama PJO"
                                                                          v-model="formValues.namaPjo"
                                                                      />-->
                    <select
                      class="form-select form-select-sm"
                      name="kompetensiPjo"
                      id="kompetensiPjo"
                      v-model="formValues.kompetensiPjo"
                    >
                      <option disabled value="" selected>
                        Pilih Kompetensi PJO
                      </option>
                      <option
                        :value="row.value"
                        v-for="(row, index) in kompetensiPjoOpt"
                        :key="index"
                      >
                        {{ row.label }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label
                      for="tanggalPengesahan"
                      class="form-label fs-8 fw-bold"
                      >Tanggal Pengesahan</label
                    >
                    <datepicker
                      v-model="formValues.tanggalPengesahan"
                      value=""
                      name="tanggalPengesahan"
                      placeholder="Masukkan Tanggal Pengesahan"
                      class="form-control fs-9"
                      input-class="fw-bold"
                      format="yyyy-MM-dd"
                    ></datepicker>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-md-6">
                    <label
                      for="nomorSuratPengesahan"
                      class="form-label fs-8 fw-bold"
                      >Nomor Surat Pengesahan</label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="nomorSuratPengesahan"
                      placeholder="Masukkan Nomor Surat Pengesahan"
                      v-model="formValues.nomorSuratPengesahan"
                    />
                  </div>
                  <div class="col-md-6">
                    <label
                      for="fileDokumenPengesahan"
                      class="form-label fs-8 fw-bold"
                      >File Dokumen Pengesahan</label
                    >
                    <div class="input-group mb-1">
                      <input
                        type="file"
                        ref="fileDokumenPengesahan"
                        accept=".pdf"
                        class="form-control fs-9"
                        id="inputGroupFile04"
                        @change="handleChangeFile('suratPengesahan')"
                        aria-describedby="inputGroupFileAddon04"
                        aria-label="Upload"
                      />
                      <button
                        class="btn btn-outline-secondary fs-9 border border-start-0"
                        type="button"
                        id="inputGroupFileAddon04"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-cloud-arrow-up"
                          style="color: #000000"
                        />
                      </button>
                    </div>
                    <div
                      v-if="validasiFile.sizeSuratPengesahan"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ukuran file melebihi batas (Max:
                      {{ max_file_size }}MB).
                    </div>
                    <div
                      v-if="validasiFile.typeSuratPengesahan"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ekstensi file tidak sesuai, Mohon tambahkan file PDF.
                    </div>
                    <div v-if="kontraktor.filePengesahan != null" class="fs-8">
                      File saat ini :
                      <a
                        class="text-danger pointer"
                        @click="downloadFile(kontraktor.filePengesahan)"
                        >{{ kontraktor.filePengesahan }}</a
                      >
                    </div>
                  </div>
                </div>
                <div class="row mb-1">
                  <div class="col-md-12">
                    <p
                      class="mb-1"
                      style="
                        font-family: 'Inter-Thin';
                        font-size: 0.9rem;
                        letter-spacing: 0.1rem;
                        font-weight: bold;
                      "
                    >
                      INFORMASI UMUM
                    </p>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-3">
                    <label for="inisial" class="form-label fs-8 fw-bold"
                      >Inisial</label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      :class="{ 'is-invalid': inisialDuplicateError }"
                      id="inisial"
                      placeholder="Masukkan Inisial"
                      v-model="formValues.inisial"
                      @blur="checkInisialDuplicate"
                      @input="inisialDuplicateError = ''"
                    />
                    <div
                      v-if="inisialChecking"
                      class="fs-8 text-muted fst-italic mt-1"
                    >
                      Memeriksa inisial…
                    </div>
                    <div
                      v-if="inisialDuplicateError"
                      class="fs-8 text-danger fst-italic mt-1"
                    >
                      {{ inisialDuplicateError }}
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label for="Klasifikasi" class="form-label fs-8 fw-bold"
                      >Klasifikasi<span class="text-danger fs-6">*</span></label
                    >
                    <select
                      id="Klasifikasi"
                      v-model="formValues.klasifikasi"
                      @change="
                        formValues.klasifikasi == 'Inti'
                          ? (wajibIUJP = true)
                          : (wajibIUJP = false)
                      "
                      class="form-select form-select-sm"
                    >
                      <option disabled value="" selected>
                        Pilih Klasifikasi
                      </option>
                      <option
                        v-for="klas in klasifikasiOpt"
                        :key="klas"
                        :value="klas"
                      >
                        {{ klas }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-3">
                    <label for="kualilifikasi" class="form-label fs-8 fw-bold"
                      >Kualifikasi Usaha<span class="text-danger fs-6"
                        >*</span
                      ></label
                    >
                    <select
                      id="kualilifikasi"
                      v-model="formValues.kualifikasiUsaha"
                      class="form-select form-select-sm"
                    >
                      <option disabled value="" selected>
                        Pilih Kualifikasi Usaha
                      </option>
                      <option
                        v-for="kuali in kualifikasiOpt"
                        :key="kuali.value"
                        :value="kuali.value"
                      >
                        {{ kuali.label }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-3">
                    <label for="wilayah" class="form-label fs-8 fw-bold"
                      >Wilayah</label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="wilayah"
                      :disabled="true"
                      placeholder="Masukkan wilayah"
                      v-model="formValues.wilayah"
                    />
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-md-6">
                    <label for="alamat" class="form-label fs-8 fw-bold"
                      >Alamat</label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="alamat"
                      placeholder="Masukkan Alamat"
                      v-model="formValues.alamat"
                    />
                  </div>
                  <div class="col-md-2">
                    <label for="provinsi" class="form-label fs-8 fw-bold"
                      >Provinsi</label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="provinsi"
                      placeholder="Masukkan Provinsi"
                      v-model="formValues.provinsi"
                    />
                  </div>
                  <div class="col-md-2">
                    <label for="emailPic" class="form-label fs-8 fw-bold"
                      >Email PJO</label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="emailPic"
                      placeholder="Masukkan Email"
                      v-model="formValues.emailPic"
                    />
                  </div>
                  <div class="col-md-2">
                    <label for="hpPic" class="form-label fs-8 fw-bold"
                      >No. Handphone PJO</label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="hpPic"
                      placeholder="Masukkan Nomor Handphone"
                      v-model="formValues.hpPic"
                    />
                  </div>
                </div>
                <div class="row mb-1">
                  <div class="col-md-12">
                    <p
                      class="mb-1"
                      style="
                        font-family: 'Inter-Thin';
                        font-size: 0.9rem;
                        letter-spacing: 0.1rem;
                        font-weight: bold;
                      "
                    >
                      IZIN LEGALITAS
                    </p>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="nomorNIB" class="form-label fs-8 fw-bold"
                      >Nomor NIB <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="nomorNIB"
                      placeholder="Masukkan Nomor NIB"
                      v-model="formValues.nomorNIB"
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="fileDokumenNIB" class="form-label fs-8 fw-bold"
                      >File Dokumen NIB
                      <span class="text-danger fs-6">*</span></label
                    >
                    <div class="input-group mb-1">
                      <input
                        type="file"
                        ref="fileDokumenNIB"
                        accept=".pdf"
                        class="form-control fs-9"
                        id="inputGroupFile04"
                        @change="handleChangeFile('nib')"
                        aria-describedby="inputGroupFileAddon04"
                        aria-label="Upload"
                      />
                      <button
                        class="btn btn-outline-secondary fs-9 border border-start-0"
                        type="button"
                        id="inputGroupFileAddon04"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-cloud-arrow-up"
                          style="color: #000000"
                        />
                      </button>
                    </div>
                    <div
                      v-if="validasiFile.sizeNib"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ukuran file melebihi batas (Max:
                      {{ max_file_size }}MB).
                    </div>
                    <div
                      v-if="validasiFile.typeNib"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ekstensi file tidak sesuai, Mohon tambahkan file PDF.
                    </div>
                    <div v-if="kontraktor.fileNib != null" class="fs-8">
                      File saat ini :
                      <a
                        class="text-danger pointer"
                        @click="downloadFile(kontraktor.fileNib)"
                        >{{ kontraktor.fileNib }}</a
                      >
                    </div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-md-4">
                    <label for="nomorIUJP" class="form-label fs-8 fw-bold"
                      >Nomor IUJP
                      <span v-if="wajibIUJP" class="text-danger fs-6"
                        >*</span
                      ></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="nomorIUJP"
                      placeholder="Masukkan Nomor IUJP"
                      v-model="formValues.nomorIUJP"
                    />
                  </div>
                  <div class="col-md-4">
                    <label for="masaBerlakuIUJP" class="form-label fs-8 fw-bold"
                      >Masa Berlaku IUJP
                      <span v-if="wajibIUJP" class="text-danger fs-6"
                        >*</span
                      ></label
                    >
                    <!-- <input
                    type="text"
                    class="form-control fs-9"
                    id="masaBerlakuIUJP"
                    placeholder="Masukkan Masa Berlaku IUJP" v-model="formValues.masaBerlakuIUJP"
                /> -->
                    <datepicker
                      v-model="formValues.masaBerlakuIUJP"
                      value=""
                      name="masaBerlakuIUJP"
                      placeholder="Masukkan masa berlaku IUJP"
                      class="form-control fs-9"
                      input-class="fw-bold"
                      format="yyyy-MM-dd"
                    ></datepicker>
                  </div>
                  <div class="col-md-4">
                    <label for="fileDokumenIUJP" class="form-label fs-8 fw-bold"
                      >File Dokumen IUJP
                      <span v-if="wajibIUJP" class="text-danger fs-6"
                        >*</span
                      ></label
                    >
                    <div class="input-group mb-1">
                      <input
                        type="file"
                        ref="fileDokumenIUJP"
                        accept=".pdf"
                        class="form-control fs-9"
                        id="inputGroupFile04"
                        aria-describedby="inputGroupFileAddon04"
                        @change="handleChangeFile('iujp')"
                        aria-label="Upload"
                      />
                      <button
                        class="btn btn-outline-secondary fs-9 border border-start-0"
                        type="button"
                        id="inputGroupFileAddon04"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-cloud-arrow-up"
                          style="color: #000000"
                        />
                      </button>
                    </div>
                    <div
                      v-if="validasiFile.sizeIujp"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ukuran file melebihi batas (Max:
                      {{ max_file_size }}MB).
                    </div>
                    <div
                      v-if="validasiFile.typeIujp"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ekstensi file tidak sesuai, Mohon tambahkan file PDF.
                    </div>
                    <div v-if="kontraktor.fileIujp != null" class="fs-8">
                      File saat ini :
                      <a
                        class="text-danger pointer"
                        @click="downloadFile(kontraktor.fileIujp)"
                        >{{ kontraktor.fileIujp }}</a
                      >
                    </div>
                  </div>
                </div>

                <div class="col-md-12 mb-4">
                  <div class="w-100 border border-1 rounded p-3">
                    <div class="row mb-2">
                      <div class="col-md-12 mb-4">
                        <label class="form-label fs-6 fw-bold"
                          >KBLI<span class="text-danger fs-6">*</span></label
                        >
                      </div>
                      <div
                        class="row mb-1"
                        v-for="(row, index) in formValues.kblis"
                        :key="index"
                      >
                        <div v-if="row.show == true">
                          <div class="row mb-2">
                            <div class="col-md-3">
                              <label
                                for="kodeKbli"
                                class="form-label fs-8 fw-bold"
                                >Kode KBLI</label
                              >
                              <input
                                type="text"
                                class="form-control fs-9"
                                id="kodeKbli"
                                placeholder="Masukkan Kode KBLI"
                                v-model="row.kode"
                              />
                            </div>
                            <div class="col-md-8">
                              <label
                                for="judulKbli"
                                class="form-label fs-8 fw-bold"
                                >Judul KBLI</label
                              >
                              <input
                                type="text"
                                class="form-control fs-9"
                                id="judulKbli"
                                placeholder="Masukkan Judul KBLI"
                                v-model="row.deskripsi"
                              />
                            </div>
                            <!--                                                                <div
                                                                                                    class="col-md-1 d-flex align-items-right justify-content-end"
                                                                                                >
                                                                                                    <a
                                                                                                        style="
                                                                                                            font-family: 'Inter-Bold';
                                                                                                            font-size: 1.2rem;
                                                                                                            color: #dd3737;
                                                                                                            cursor: pointer;
                                                                                                        "
                                                                                                        @click="hapusKBLI(index)"
                                                                                                        ><font-awesome-icon
                                                                                                            icon="fa-solid fa-trash"
                                                                                                            style=""
                                                                                                    /></a>
                                                                                                </div>-->
                          </div>
                          <div class="row mb-2" v-if="row.show == true">
                            <div class="col-md-6">
                              <label
                                for="nibKbli"
                                class="form-label fs-8 fw-bold"
                                >NIB</label
                              >
                              <input
                                disabled
                                type="text"
                                class="form-control fs-9"
                                id="nibKbli"
                                placeholder="Masukkan Status NIB"
                                v-model="row.nibKbli"
                              />
                            </div>
                            <div class="col-md-6">
                              <label
                                for="tingkatResiko"
                                class="form-label fs-8 fw-bold"
                                >Tingkat Resiko OSS<span
                                  class="text-danger fs-6"
                                  >*</span
                                ></label
                              >
                              <select
                                class="form-select form-select-sm"
                                name="tingkatResiko"
                                id="tingkatResiko"
                                v-model="row.tingkatResiko"
                              >
                                <option
                                  :value="row.value"
                                  v-for="(row, indexz) in tingkatResiko"
                                  :key="indexz"
                                >
                                  {{ row.label }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="row mb-2">
                            <div class="col-md-6">
                              <label
                                for="sertifikasi"
                                class="form-label fs-8 fw-bold"
                                >Sertifikasi Standar</label
                              >
                              <input
                                disabled
                                type="text"
                                class="form-control fs-9"
                                id="sertifikasi"
                                placeholder="Masukkan Sertifikasi Standar"
                                v-model="row.sertifikasiStandar"
                              />
                            </div>
                            <div class="col-md-6">
                              <label
                                for="FileDokumenSertifikasi"
                                class="form-label fs-8 fw-bold"
                                >File Dokumen Sertifikasi
                                <span
                                  v-if="
                                    row.tingkatResiko == 2 ||
                                    row.tingkatResiko == 3
                                  "
                                  class="text-danger fs-6"
                                  >*</span
                                >
                              </label>
                              <div class="input-group">
                                <input
                                  :disabled="
                                    row.tingkatResiko == 1 ||
                                    row.tingkatResiko == 4
                                  "
                                  type="file"
                                  ref="FileDokumenSertifikasi"
                                  accept=".pdf"
                                  class="form-control fs-9"
                                  id="inputGroupFile04"
                                  @change="
                                    handleChangeFileKBLI(index, 'sertifikasi')
                                  "
                                  aria-describedby="inputGroupFileAddon04"
                                  aria-label="Upload"
                                  :name="'sertifikasi' + index"
                                />
                                <button
                                  class="btn btn-outline-secondary fs-9 border border-start-0"
                                  type="button"
                                  id="inputGroupFileAddon04"
                                >
                                  <font-awesome-icon
                                    icon="fa-solid fa-cloud-arrow-up"
                                    style="color: #000000"
                                  />
                                </button>
                              </div>
                              <div
                                v-if="row.sizeSertifikasi"
                                class="fs-8 text-danger fst-italic"
                              >
                                Ukuran file melebihi batas (Max:
                                {{ max_file_size }}MB).
                              </div>
                              <div
                                v-if="row.typeSertifikasi"
                                class="fs-8 text-danger fst-italic"
                              >
                                Ekstensi file tidak sesuai, Mohon tambahkan file
                                PDF.
                              </div>
                              <div
                                v-if="row.fileSertifikat != null"
                                class="fs-8"
                              >
                                File saat ini :
                                <a
                                  class="text-danger pointer"
                                  @click="downloadFile(row.fileSertifikat)"
                                  >{{ row.fileSertifikat }}</a
                                >
                              </div>
                            </div>
                          </div>
                          <div class="row mb-4">
                            <div class="col-md-6">
                              <label for="izin" class="form-label fs-8 fw-bold"
                                >Izin</label
                              >
                              <input
                                disabled
                                type="text"
                                class="form-control fs-9"
                                id="izin"
                                v-model="row.izin"
                              />
                            </div>
                            <div class="col-md-6">
                              <label
                                for="fileDokumenIzin"
                                class="form-label fs-8 fw-bold"
                                >File Dokumen Izin
                                <span
                                  v-if="row.tingkatResiko == 4"
                                  class="text-danger fs-6"
                                  >*</span
                                >
                              </label>
                              <div class="input-group">
                                <input
                                  :disabled="
                                    row.tingkatResiko == 1 ||
                                    row.tingkatResiko == 2 ||
                                    row.tingkatResiko == 3
                                  "
                                  type="file"
                                  ref="FileDokumenIzin"
                                  accept=".pdf"
                                  class="form-control fs-9"
                                  @change="handleChangeFileKBLI(index, 'izin')"
                                  id="inputGroupFile04"
                                  aria-describedby="inputGroupFileAddon04"
                                  aria-label="Upload"
                                />
                                <button
                                  class="btn btn-outline-secondary fs-9 border border-start-0"
                                  type="button"
                                  id="inputGroupFileAddon04"
                                >
                                  <font-awesome-icon
                                    icon="fa-solid fa-cloud-arrow-up"
                                    style="color: #000000"
                                  />
                                </button>
                              </div>
                              <div
                                v-if="row.sizeIzin"
                                class="fs-8 text-danger fst-italic"
                              >
                                Ukuran file melebihi batas (Max:
                                {{ max_file_size }}MB).
                              </div>
                              <div
                                v-if="row.typeIzin"
                                class="fs-8 text-danger fst-italic"
                              >
                                Ekstensi file tidak sesuai, Mohon tambahkan file
                                PDF.
                              </div>
                              <div v-if="row.fileIzin != null" class="fs-8">
                                File saat ini :
                                <a
                                  class="text-danger pointer"
                                  @click="downloadFile(row.fileIzin)"
                                  >{{ row.fileIzin }}</a
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <p class="text-start fs-8 fst-italic">
                              Update terakhir :
                              <b>{{
                                moment(row.updatedAt).format(
                                  "YYYY-MM-DD HH:mm:ss",
                                )
                              }}</b>
                            </p>
                          </div>
                          <div
                            class="col-md-12"
                            :hidden="index == formValues.kblis.length - 1"
                          >
                            <hr
                              style="
                                border: none;
                                height: 0.3rem;
                                color: #c4c4c4;
                                background-color: #c4c4c4;
                              "
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <a
                            style="
                              font-family: 'Inter-Bold';
                              font-size: 0.75rem;
                              color: #dd3737;
                              cursor: pointer;
                            "
                            @click="tambahKBLI()"
                            ><font-awesome-icon
                              icon="fa-solid fa-circle-plus"
                              style=""
                            />
                            Tambah KBLI</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 mb-4">
                  <div class="w-100 border border-1 rounded p-3">
                    <div class="row mb-2">
                      <div class="col-md-12 mb-4">
                        <label class="form-label fs-6 fw-bold"
                          >Bidang IUJP<span
                            v-if="wajibIUJP"
                            class="text-danger fs-6"
                            >*</span
                          ></label
                        >
                      </div>
                      <div
                        class="row mb-1"
                        v-for="(row, index) in formValues.bidangs"
                        :key="index"
                      >
                        <div class="col-md-3">
                          <label for="bidang" class="form-label fs-8 fw-bold"
                            >Bidang</label
                          >
                          <!-- <input
                                 type="text"
                                 class="form-control fs-9"
                                 id="bidang"
                                 placeholder="Masukkan Bidang"
                                 v-model="row.NMBIDANG"
                             /> -->
                          <select
                            v-model="row.NMBIDANG"
                            id="selectBox"
                            @change="handleChangeBidang(index)"
                            class="form-select form-select-sm"
                          >
                            <option
                              v-for="rbid in ref_bidang"
                              :key="rbid.id"
                              :value="rbid.bidang"
                            >
                              {{ rbid.bidang }}
                            </option>
                          </select>
                          <!-- <div v-if="row.NMBIDANG!=null">
                              Selected : {{row.NMBIDANG}}
                              </div> -->
                        </div>
                        <div class="col-md-8">
                          <label for="subBidang" class="form-label fs-8 fw-bold"
                            >Sub Bidang</label
                          >
                          <!-- <input
                                 type="text"
                                 class="form-control fs-9"
                                 id="subBidang"
                                 placeholder="Masukkan Sub Bidang"
                                 v-model="row.SUBBIDANG"
                             /> -->

                          <select
                            v-model="row.SUBBIDANG"
                            id="selectBox"
                            @change="handleChangeSubbidang(index)"
                            class="form-select form-select-sm"
                          >
                            <option
                              v-for="rsbid in ref_subbidang[index]"
                              :key="rsbid.id"
                              :value="rsbid.bidang"
                            >
                              {{ rsbid.bidang }}
                            </option>
                          </select>
                          <!-- <div v-if="row.SUBBIDANG!=null">
                              Selected : {{row.SUBBIDANG}}
                              </div> -->
                        </div>
                        <div
                          class="col-md-1 d-flex align-items-center justify-content-center"
                        >
                          <a
                            style="
                              font-family: 'Inter-Bold';
                              font-size: 1.2rem;
                              color: #dd3737;
                              cursor: pointer;
                            "
                            @click="hapusBidang(index)"
                            ><font-awesome-icon
                              icon="fa-solid fa-trash"
                              style=""
                          /></a>
                        </div>
                        <div
                          class="col-md-12"
                          :hidden="index == formValues.bidangs.length - 1"
                        >
                          <hr
                            style="
                              border: none;
                              height: 0.3rem;
                              color: #c4c4c4;
                              background-color: #c4c4c4;
                            "
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <a
                            style="
                              font-family: 'Inter-Bold';
                              font-size: 0.75rem;
                              color: #dd3737;
                              cursor: pointer;
                            "
                            @click="tambahBidang()"
                            ><font-awesome-icon
                              icon="fa-solid fa-circle-plus"
                              style=""
                            />
                            Tambah Bidang & Sub Bidang</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 d-flex justify-content-end">
                    <button
                      type="button"
                      @click="clickSimpan()"
                      class="btn btn_cari w-25"
                      :disabled="
                        !userData.role.includes('ADMIN') &&
                        userData.role !== 'kontraktor'
                      "
                    >
                      Simpan
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>
<style>
section .vuejs3-datepicker__calendar-topbar {
  min-height: auto;
}

.vuejs3-datepicker__value {
  font-size: 0.7rem !important;
  border: 0px !important;
  padding: 0px !important;
}
.vuejs3-datepicker__icon svg {
  height: 0.8rem;
}

.vuejs3-datepicker__content {
  font-size: 0.8rem !important;
  margin-left: 0.3rem !important;
  margin-bottom: -1rem !important;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent white overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Make sure it's above other elements on the page */
}

.loading-spinner {
  /* Add your loading spinner styles here */
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  /* animation: spin 1s linear infinite; */
}

/* @keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} */
</style>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import GlobalDataMixin from "../../GlobalDataMixin";
import Datepicker from "vuejs3-datepicker";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

import axios from "axios";
import Swal from "sweetalert2";

import {
  API_BASE_URL,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_CHECK_INISIAL,
  CMS_UPLOAD,
  CMS_UPLOAD_KBLI,
  CMS_DOWNLOAD,
  CMS_GET_BIDANG,
  CMS_SET_SUBKONTRAKTOR,
} from "../../constants.js";
import axiosInstance from "@/plugins/axios";

const url = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_simpan = API_BASE_URL + CMS_SET_SUBKONTRAKTOR;
const url_upload = API_BASE_URL + CMS_UPLOAD;
const url_upload_kbli = API_BASE_URL + CMS_UPLOAD_KBLI;
const url_download = API_BASE_URL + CMS_DOWNLOAD;
const url_get_bidang = API_BASE_URL + CMS_GET_BIDANG;
const max_file_size = 5; // MB

export default {
  mixins: [GlobalDataMixin],
  name: "viewEditKontraktorPage",
  components: { DefaultLayout, Datepicker },
  data() {
    return {
      isLoading: true,
      jumlahFile: 0,
      uploadedFile: 0,
      tingkatResiko: [
        { value: 1, label: "Rendah" },
        { value: 2, label: "Menengah Rendah" },
        { value: 3, label: "Menengah Tinggi" },
        { value: 4, label: "Tinggi" },
      ],
      kompetensiPjoOpt: [
        { value: "POP", label: "POP (Pengawas Operasional Pertama)" },
        { value: "POM", label: "POM (Pengawas Operasional Madya)" },
        { value: "POU", label: "POU (Pengawas Operasional Utama)" },
      ],
      kontraktor: {},
      bidang: [],
      kbli: [],
      bd: [],
      sbd: [],
      ref_bidangall: [],
      ref_bidang: [],
      ref_subbidang: [[]],
      subkontraktor: [
        "PT Sapta Indrasejati (SIS)",
        "PT Rezki Batulicin Transport",
        "PT Golden Energi Cemerlang Lestari (GECL)",
        "PT Merdeka Sejati",
        "PT Golden Gemilang",
        "PT Jaya Sentosa",
      ],
      klasifikasiOpt: ["Inti", "Non Inti"],
      temp_kblis: [
        { kode: "", deskripsi: "", tingkatResiko: "", tingkatResikoStr: "" },
      ],
      final_kblis: [],
      deleted_kblis: [],
      upload_kblis: [],
      added_kblis: [],
      wajibIUJP: false,
      formValues: {
        namaKontraktor: "",
        logo: "",
        inisial: "",
        klasifikasi: "",
        kualifikasiUsaha: "",
        wilayah: "",
        alamat: "",
        provinsi: "",
        emailPic: "",
        hpPic: "",
        nomorNIB: "",
        nomorIUJP: "",
        namaPjo: "",
        nomorSuratPengesahan: "",
        tanggalPengesahan: "",
        masaBerlakuIUJP: "",
        kompetensiPjo: "",
        // kblis: [{ kode: "", deskripsi: "", tingkatResiko: "", tingkatResikoStr: "" }],
        kblis: [],
        bid: [],
        subbid: [],
        bidangs: [{ NMBIDANG: "", SUBBIDANG: "" }],
        fileDokumenPengesahan: "",
        fileDokumenIUJP: "",
        fileDokumenNIB: "",
      },
      validasiFile: {
        typeIujp: false,
        sizeIujp: false,
        typeNib: false,
        sizeNib: false,
        typeSuratPengesahan: false,
        sizeSuratPengesahan: false,
      },
      kualifikasiOpt: [
        { value: 1, label: "Kecil" },
        { value: 2, label: "Sedang" },
        { value: 3, label: "Besar" },
      ],
      count_kbli_previous: null,
      count_bidangs_previous: null,
      inisialAsLoaded: "",
      inisialDuplicateError: "",
      inisialChecking: false,
      inisialCheckToken: 0,
      token:
        "Bearer eyJhbGciOiJIUzI1NiJ9.eyJwcm9maWxlX25hbWUiOiJrb250cmFrdG9yIiwic3ViIjoia29udHJha3RvciIsImtleSI6NjI3LCJpYXQiOjE3MDUwMjkyMDh9.37zBNhGh_eoujhqJLZeNts0GGmp8klwSH39AHDXaflY",
    };
  },
  mounted() {
    this.getBidang();
    this.fetchData(this.$route.params.id);
  },
  methods: {
    preventSubmit() {
      console.log("prevent submit");
    },
    /** true = inisial bentrok / tidak dipakai (when API says available === false). */
    isInisialDuplicateFromResponse(payload) {
      if (!payload || typeof payload !== "object") {
        return false;
      }
      if ("available" in payload) {
        return payload.available === false;
      }
      const inner = payload.data;
      if (inner && typeof inner === "object" && "available" in inner) {
        return inner.available === false;
      }
      return false;
    },
    async fetchInisialDuplicateFromApi() {
      const trimmed = (this.formValues.inisial || "").trim();
      if (!trimmed) {
        return { duplicate: false };
      }
      const idKontraktor = Number(this.$route.params.id);
      if (idKontraktor == null || idKontraktor === "") {
        return { duplicate: false };
      }
      const loaded = (this.inisialAsLoaded || "").trim().toLowerCase();
      if (trimmed.toLowerCase() === loaded) {
        return { duplicate: false };
      }
      const { data } = await axiosInstance.get(CMS_CHECK_INISIAL, {
        params: {
          id_kontraktor: idKontraktor,
          inisial: trimmed,
        },
      });
      return { duplicate: this.isInisialDuplicateFromResponse(data) };
    },
    async checkInisialDuplicate() {
      this.inisialDuplicateError = "";
      const trimmed = (this.formValues.inisial || "").trim();
      if (!trimmed) {
        return;
      }
      const token = ++this.inisialCheckToken;
      this.inisialChecking = true;
      try {
        const { duplicate } = await this.fetchInisialDuplicateFromApi();
        if (token !== this.inisialCheckToken) {
          return;
        }
        if (duplicate) {
          this.inisialDuplicateError =
            "Inisial sudah digunakan. Silakan gunakan inisial lain.";
        }
      } catch (e) {
        if (token !== this.inisialCheckToken) {
          return;
        }
        const msg =
          e.response?.data?.message ||
          e.response?.data?.status?.message ||
          "Gagal memeriksa inisial.";
        this.inisialDuplicateError = msg;
      } finally {
        if (token === this.inisialCheckToken) {
          this.inisialChecking = false;
        }
      }
    },
    async validateInisialBeforeSubmit() {
      this.inisialDuplicateError = "";
      const trimmed = (this.formValues.inisial || "").trim();
      if (!trimmed) {
        return true;
      }
      this.inisialChecking = true;
      try {
        const { duplicate } = await this.fetchInisialDuplicateFromApi();
        if (duplicate) {
          this.inisialDuplicateError =
            "Inisial sudah digunakan. Silakan gunakan inisial lain.";
          return false;
        }
        return true;
      } catch (e) {
        const msg =
          e.response?.data?.message ||
          e.response?.data?.status?.message ||
          "Gagal memeriksa inisial.";
        this.inisialDuplicateError = msg;
        return false;
      } finally {
        this.inisialChecking = false;
      }
    },
    fetchData(id) {
      axios
        .get(url + id, { headers: { accept: "application/json" } })
        .then((response) => {
          this.kontraktor = response.data.detailKontraktor;
          // set value form edit
          this.formValues.namaKontraktor = this.kontraktor.namaKontraktor;
          this.formValues.inisial = this.kontraktor.inisial;
          this.inisialAsLoaded = (this.kontraktor.inisial || "").trim();
          this.inisialDuplicateError = "";
          this.formValues.klasifikasi = this.kontraktor.jenis;
          this.formValues.kualifikasiUsaha = this.kontraktor.kualifikasiUsaha;
          this.formValues.wilayah = this.kontraktor.wilayah;
          this.formValues.nomorNIB = this.kontraktor.nib;
          this.formValues.nomorIUJP = this.kontraktor.iujp;
          this.formValues.masaBerlakuIUJP = this.kontraktor.masaBerlaku;
          this.formValues.nomorSuratPengesahan =
            this.kontraktor.noPengesahanPjo;
          this.formValues.tanggalPengesahan =
            this.kontraktor.tglSuratPengesahan;
          this.formValues.namaPjo = this.kontraktor.namaPjo;
          this.formValues.kompetensiPjo = this.kontraktor.kompetensiPjo;

          if (this.formValues.klasifikasi.toLocaleLowerCase() == "inti") {
            this.wajibIUJP = true;
          }
          this.formValues.alamat = this.kontraktor.alamat;
          this.formValues.provinsi = this.kontraktor.provinsi;
          this.formValues.emailPic = this.kontraktor.picEmail;
          this.formValues.hpPic = this.kontraktor.picPhone;
          // end : set value form edit

          // loop bidang-subbidang
          var arr_bid = [];
          var arr_bidx = [];
          var abd = [];
          var asbd = [];
          var temp_key = "";
          var b = 0;
          var sb = 1;
          for (var key in this.kontraktor.bidang) {
            var subi = this.kontraktor.bidang[key];
            if (temp_key != key) {
              temp_key = key;
              b += 1;
              sb = 1;
            }
            abd.push(b + ". " + key);

            for (var xx in subi) {
              arr_bid.push({
                bidang: b + ". " + key,
                subBidang: b + "." + sb + ". " + subi[xx],
              });
              arr_bidx.push({
                bidang: key,
                subBidang: subi[xx],
              });
              asbd.push(b + "." + sb + ". " + subi[xx]);
              sb++;
            }
          }
          this.bidang = arr_bid;
          if (arr_bidx.length) {
            let arr_bids = [];
            for (var z in arr_bidx) {
              var bd = arr_bidx[z];
              arr_bids.push({
                NMBIDANG: bd.bidang,
                SUBBIDANG: bd.subBidang.split("-")[0],
                is_verified: bd.subBidang.split("-")[1],
                notes: bd.subBidang.split("-")[2],
              });

              // set ref sub bidang saat fetch data
              let nmb = this.ref_bidangall.filter(
                (option) => option.bidang === bd.bidang,
              );
              if (nmb.length > 0) {
                this.ref_subbidang.push(this.getSubBidang(nmb[0].id, z));
              }
            }
            // console.log('cok:',this.ref_subbidang);
            this.formValues.bidangs = arr_bids;
          }

          // end loop bidang-subbidang

          let kbli = response.data.dataKbli;
          if (kbli.length > 0) {
            let arr_kbli = [];
            let arr_kbli_o = [];
            for (var k in kbli) {
              var kb = kbli[k];
              let izin = kbli[k].noKbli == "9900" ? "Terbit" : "-";
              let nibKbli =
                this.kontraktor.nib != "" ? "Terbit" : "Tidak Terbit";
              arr_kbli.push({
                id: kb.id,
                kode: kb.noKbli,
                deskripsi: kb.deskripsi,
                izin: izin,
                sertifikasiStandar: "-",
                nibKbli: nibKbli,
                tingkatResiko: kb.tingkatResiko,
                // tingkatResikoStr: kb.tingkatResikoStr,
                show: true,
                deleted: false,
                updatedAt: kb.updatedAt,
                sizeSertifikasi: false,
                typeSertifikasi: false,
                sizeIzin: false,
                typeIzin: false,
                fileSertifikat: kb.fileSertifikat,
                fileIzin: kb.fileIzin,
              });
              arr_kbli_o.push({
                id: kb.id,
                kode: kb.noKbli,
                deskripsi: kb.deskripsi,
                izin: izin,
                sertifikasiStandar: "-",
                nibKbli: nibKbli,
                tingkatResiko: kb.tingkatResiko,
                // tingkatResikoStr: kb.tingkatResikoStr,
                updatedAt: kb.updatedAt,
              });
            }
            this.formValues.kblis = arr_kbli;
            this.temp_kblis = arr_kbli_o;
            // console.log("a:", this.formValues.kblis)
            // console.log('b:',this.temp_kblis)
          }
          this.count_kbli_previous = this.formValues.kblis.length;
          this.count_bidangs_previous = this.formValues.bidangs.length;
          this.bd = abd;
          this.sbd = asbd;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data Detail Kontraktor : " + error.message);
          console.error("Error fetching data:", error.message);
        });
    },
    tambahKBLI() {
      // let izin = kbli[k].noKbli =='9900'?'Terbit':'-';
      // let nibKbli = this.kontraktor.nib!=''?'Terbit':'Tidak Terbit';

      this.formValues.kblis.push({
        kode: "",
        deskripsi: "",
        tingkatResiko: "",
        izin: "-",
        sertifikasiStandar: "-",
        nibKbli: "Tidak Terbit",
        show: true,
      });
    },
    hapusKBLI(index) {
      if (this.formValues.kblis[index].id != null) {
        this.deleted_kblis.push(this.formValues.kblis[index]);
      } else if (this.formValues.kblis[index].id == null) {
        this.added_kblis = this.added_kblis.filter(
          (item) => item.kode !== this.formValues.kblis[index].kode,
        );
      }

      if (this.$refs.FileDokumenSertifikasi[index] != null) {
        this.$refs.FileDokumenSertifikasi[index].value = "";
      }
      if (this.$refs.FileDokumenIzin[index] != null) {
        this.$refs.FileDokumenIzin[index].value = "";
      }

      // console.log(this.$refs.FileDokumenIzin);

      // this.formValues.kblis.splice(index,1)
      this.formValues.kblis[index].show = false;
      this.formValues.kblis[index].deleted = true;
    },
    tambahBidang() {
      this.formValues.bidangs.push({ NMBIDANG: "", SUBBIDANG: "" });
    },
    hapusBidang(index) {
      this.formValues.bidangs.splice(index, 1);
      this.ref_subbidang.splice(index, 1);
    },
    getBidang() {
      axios
        .post(
          url_get_bidang,
          {},
          {
            headers: {
              role: "kontraktor",
              Authorization: this.token,
              accept: "*/*",
            },
          },
        )
        .then((response) => {
          // console.log("response getBidang: ", response)
          // console.log(this.jumlahFile);
          // console.log(this.uploadedFile);
          if (response.status == 200) {
            let data_bidang = response.data.data;
            this.ref_bidangall = data_bidang;
            // let rsb = [];
            for (let i = 0; i < data_bidang.length; i++) {
              if (data_bidang[i].id == data_bidang[i].bidangParent) {
                this.ref_bidang.push({
                  id: data_bidang[i].id,
                  bidang: data_bidang[i].bidang,
                });
              }
              // console.log('getSubbidang: ',data_bidang[i].id)
              // this.getSubBidang(data_bidang[i].id,i);
              // rsb.push({id:data_bidang[i].id,bidang:data_bidang[i].bidang})
              // this.ref_subbidang[i] = rsb;
            }
            this.fetchData(this.$route.params.id); // get data kontraktor
          }
        })
        .catch((error) => {
          console.log("error getBidang : ", error);
          // alert("error with code [1]")
          if (error.response.status == 500) {
            alert(
              "Error " +
                error.response.data.code +
                " getBidang : " +
                error.response.data.message,
            );
          } else if (error.response.status == 400) {
            alert(
              "Error " +
                error.response.data.code +
                " getBidang : " +
                error.response.data.message,
            );
          } else if (error.response.status == 401) {
            alert(
              "Error " +
                error.response.data.code +
                " getBidang : " +
                error.response.data.message,
            );
          }
        })
        .then(() => {});
    },
    getSubBidang(id_parent, index) {
      this.ref_subbidang[index] = [];
      let rsb = [];
      for (let i = 0; i < this.ref_bidangall.length; i++) {
        if (
          this.ref_bidangall[i].bidangParent == id_parent &&
          this.ref_bidangall[i].id != id_parent
        ) {
          rsb.push({
            id: this.ref_bidangall[i].id,
            bidang: this.ref_bidangall[i].bidang,
          });
        }
      }
      // console.log('getsubbid : ',index,' ',rsb);
      this.ref_subbidang[index] = rsb;
    },
    // getIDBidang(nama){

    //     return
    // },
    handleChangeBidang(index) {
      // console.log(this.formValues.bidangs)
      console.log(
        `Selected bidang ${index + 1}:`,
        this.formValues.bidangs[index].NMBIDANG,
      );
      const matchingOption = this.ref_bidangall.find(
        (option) => option.bidang === this.formValues.bidangs[index].NMBIDANG,
      );
      let id_parent = matchingOption.id;

      this.getSubBidang(id_parent, index);
    },
    handleChangeSubbidang(index) {
      console.log(
        `Selected sub bidang ${index + 1}:`,
        this.formValues.bidangs[index].SUBBIDANG,
      );
    },
    simpanEditProfile(files, purposes) {
      // console.log('tp',this.formValues.tanggalPengesahan);
      let bodyJsonProfile = {
        id: this.$route.params.id,
        namaKontraktor: this.formValues.namaKontraktor,
        namaPjo: this.formValues.namaPjo,
        kompetensiPjo: this.formValues.kompetensiPjo,
        inisial: this.formValues.inisial,
        nib: this.formValues.nomorNIB != "" ? true : false,
        noNib: this.formValues.nomorNIB,
        iujp:
          this.formValues.klasifikasi != "" &&
          this.formValues.klasifikasi != null &&
          this.formValues.klasifikasi != "Non Inti"
            ? true
            : false,
        noIujp: this.formValues.nomorIUJP,
        tglExpIujp:
          this.formValues.masaBerlakuIUJP != null &&
          this.formValues.masaBerlakuIUJP != ""
            ? moment(this.formValues.masaBerlakuIUJP).format("YYYY-MM-DD")
            : null,
        // "kblis":this.formValues.kblis,
        kblis: this.final_kblis,
        bidangUsahaGems: JSON.stringify(this.formValues.bidangs),
        // image: this.formValues.logo,
        noPengesahanPjo: this.formValues.nomorSuratPengesahan,
        tglSuratPengesahan:
          this.formValues.tanggalPengesahan != null &&
          this.formValues.tanggalPengesahan != ""
            ? moment(this.formValues.tanggalPengesahan).format("YYYY-MM-DD")
            : null,
        alamat: this.formValues.alamat,
        provinsi: this.formValues.provinsi,
        picEmail: this.formValues.emailPic,
        picPhone: this.formValues.hpPic,
        kualifikasiUsaha: parseInt(this.formValues.kualifikasiUsaha),
      };
      // console.log("body nya = ", bodyJsonProfile)
      axios
        .post(url_simpan, bodyJsonProfile, {
          headers: {
            role: this.userData.role.includes("ADMIN")
              ? "isafe"
              : this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
          params: {
            created_by: this.userData.name || this.userData.email || "UNKNOWN",
          },
        })
        .then((response) => {
          console.log("response simpanEditProfile: ", response);
          // console.log(this.jumlahFile);
          // console.log(this.uploadedFile);
          if (response.data.kbli.length > 0) {
            // let zz = 0;
            for (var x in response.data.kbli) {
              let kk = response.data.kbli[x];
              console.log("ini id kbli : ", kk.id);
              console.log("ini balikan : ", kk);
              console.log("cek if :", kk.id != null);
              let lastindex_uploadkblis = this.upload_kblis.length;

              if (kk.id != null) {
                console.log("test : ", kk.id);
                // this.formValues.kblis.push({id:kk.id});
                this.upload_kblis.push({
                  id: kk.id,
                  index: lastindex_uploadkblis,
                  req_sertifikasi: this.added_kblis[x]?.req_sertifikasi,
                  req_izin: this.added_kblis[x]?.req_izin,
                });
                // zz++;
              }
            }
          }
          console.log("after set kontraktor : ", this.upload_kblis);

          if (this.jumlahFile == this.uploadedFile) {
            if (this.upload_kblis.length > 0) {
              this.uploadFilesKBLI(this.upload_kblis);
            } else {
              this.alertSukses();
            }
          } else {
            this.uploadFiles(files, purposes);
          }
        })
        .catch((error) => {
          console.log("error simpanEditProfile : ", error);
          this.isLoading = false;
          const msg =
            error.response?.data?.status?.message ??
            error.response?.data?.message ??
            "Ada kesalahan sistem dalam proses simpan, silahkan ulangi proses edit profile";
          Swal.fire({
            title: "Gagal Menyimpan",
            text: msg,
            icon: "error",
          });
        })
        .then(() => {});
    },
    async uploadFiles(files, purposes) {
      for (var x in files) {
        console.log(files[x]);
        console.log(purposes[x]);
        let file = files[x];
        let pur = purposes[x];

        if (file) {
          // Get the file name
          const fileName = file.name;

          // Create a FormData object and append the file
          const formData = new FormData();
          formData.append("file", file);
          formData.append("id", this.$route.params.id);
          formData.append("purpose", pur);

          // Make the API request to upload the file
          try {
            const response = await axios.post(url_upload, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                role: this.userData.role.includes("ADMIN")
                  ? "isafe"
                  : this.userData.role,
                Authorization: "Bearer " + this.userData.token,
                accept: "*/*",
              },
            });

            // Handle the response from the server as needed
            console.log("File upload response:", response.data);
            console.log("filename : ", fileName);
            this.formValues.logo = fileName;
            this.uploadedFile += 1;
            if (this.jumlahFile == this.uploadedFile) {
              if (this.upload_kblis.length > 0) {
                this.uploadFilesKBLI(this.upload_kblis);
              } else {
                this.alertSukses();
              }
            }
          } catch (error) {
            this.isLoading = false;
            const msg = error.response?.data?.message || error.message;
            console.error("Error uploading file:", error);
            Swal.fire({
              title: "Gagal Mengunggah Berkas",
              text: msg,
              icon: "error",
            });
            return;
          }
        }
      }
    },
    async uploadFilesKBLI(arr_up_kblis) {
      console.log(this.formValues.kblis);

      for (var x in arr_up_kblis) {
        console.log(arr_up_kblis[x]);
        let ark = arr_up_kblis[x];
        // console.log(ark.index)
        // console.log(this.$refs.FileDokumenSertifikasi[ark.index])
        // console.log(this.$refs.FileDokumenIzin[ark.index])
        let fser = null;
        let fizi = null;
        if (this.$refs.FileDokumenSertifikasi[ark.index] != null) {
          fser =
            this.$refs.FileDokumenSertifikasi[ark.index].value != null
              ? this.$refs.FileDokumenSertifikasi[ark.index].files[0]
              : null;
        }

        if (this.$refs.FileDokumenIzin[ark.index] != null) {
          fizi =
            this.$refs.FileDokumenIzin[ark.index].value != null
              ? this.$refs.FileDokumenIzin[ark.index].files[0]
              : null;
        }
        // console.log('a ',fser,' b ',(this.formValues.kblis[x].fileSertifikat==null),' c ',this.formValues.kblis[x].show)
        if (fser != null) {
          // Get the file name
          var fser_name = null;
          if (fser != null) {
            fser_name = fser.name;
          }

          // Create a FormData object and append the file
          const formData = new FormData();
          formData.append("file", fser);
          formData.append("id", ark.id);
          formData.append("purpose", "sertifikasi");

          // Make the API request to upload the file
          try {
            const response = await axios.post(url_upload_kbli, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                role: this.userData.role.includes("ADMIN")
                  ? "isafe"
                  : this.userData.role,
                Authorization: "Bearer " + this.userData.token,
                accept: "*/*",
              },
            });

            // Handle the response from the server as needed
            console.log("File upload sertifikasi", ark.id, ":", response.data);
            console.log("filename : ", fser_name);

            // if(this.jumlahFile==this.uploadedFile){
            //     this.alertSukses();
            // }
          } catch (error) {
            this.isLoading = false;
            const msg = error.response?.data?.message || error.message;
            console.error("Error uploading file:", error);
            Swal.fire({
              title: "Gagal Mengunggah Berkas KBLI",
              text: msg,
              icon: "error",
            });
            return;
          }
        }

        if (fizi != null) {
          // Get the file name

          var fizi_name = null;
          if (fizi != null) {
            fizi_name = fizi.name;
          }

          // Create a FormData object and append the file
          const formData = new FormData();
          formData.append("file", fizi);
          formData.append("id", ark.id);
          formData.append("purpose", "izin");

          // Make the API request to upload the file
          try {
            const response = await axios.post(url_upload_kbli, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                role: this.userData.role,
                Authorization: "Bearer " + this.userData.token,
                accept: "*/*",
              },
            });

            // Handle the response from the server as needed
            console.log("File upload izin", ark.id, ":", response.data);
            console.log("filename : ", fizi_name);

            // if(this.jumlahFile==this.uploadedFile){
            //     this.alertSukses();
            // }
          } catch (error) {
            this.isLoading = false;
            const msg = error.response?.data?.message || error.message;
            console.error("Error uploading file:", error);
            Swal.fire({
              title: "Gagal Mengunggah Berkas KBLI",
              text: msg,
              icon: "error",
            });
            return;
          }
        }
      }

      this.alertSukses();
    },

    async clickSimpan() {
      this.compareKBLIS();

      let validasiForm = this.validasiForm();
      let validasiFormKBLIs = this.validasiFormKBLIs();
      let validasiFileKBLIs = this.validasiFileKBLIs();
      let validasiBidangIUJP = this.validasiBidangIUJP();
      if (
        !validasiForm[0] ||
        !validasiFormKBLIs[0] ||
        !validasiFileKBLIs[0] ||
        !validasiBidangIUJP[0]
      ) {
        let message =
          "Formulir Anda memiliki kesalahan pada kolom berikut:\n\n";

        if (!validasiForm[0]) {
          validasiForm[1].forEach(
            (field, index) => (message += `${index + 1}. ${field}\n`),
          );
        }

        if (!validasiFormKBLIs[0]) {
          validasiFormKBLIs[1].forEach((field, index) => {
            if (index == 0) {
              message += "\nKBLI :\n";
            }
            message += `${index + 1}. ${field}\n`;
          });
        }

        if (!validasiFileKBLIs[0]) {
          validasiFileKBLIs[1].forEach((field, index) => {
            if (index == 0) {
              message += "\nFile KBLI :\n";
            }
            message += `${index + 1}. ${field}\n`;
          });
        }

        if (!validasiBidangIUJP[0]) {
          validasiBidangIUJP[1].forEach((field, index) => {
            if (index == 0) {
              message += "\nBidang IUJP :\n";
            }
            message += `${index + 1}. ${field}\n`;
          });
        }
        alert(message);
      } else {
        const inisialOk = await this.validateInisialBeforeSubmit();
        if (!inisialOk) {
          alert(
            this.inisialDuplicateError ||
              "Inisial tidak valid atau sudah digunakan.",
          );
          return;
        }

        const confirmResult = await Swal.fire({
          title: "Konfirmasi Simpan",
          text: "Apakah Anda yakin ingin menyimpan perubahan data kontraktor ini?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#2563eb",
          cancelButtonColor: "#6b7280",
          confirmButtonText: "Ya, Simpan",
          cancelButtonText: "Batal",
          reverseButtons: true,
        });

        if (!confirmResult.isConfirmed) {
          return;
        }

        Swal.fire({
          title: "Mohon Tunggu",
          text: "Sedang mengunggah berkas dan menyimpan data kontraktor...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        this.isLoading = true;
        const fileLogo = this.$refs.fileLogo.files[0];
        const fileDokumenPengesahan = this.$refs.fileDokumenPengesahan.files[0];
        const fileDokumenIUJP = this.$refs.fileDokumenIUJP.files[0];
        const fileDokumenNIB = this.$refs.fileDokumenNIB.files[0];
        let files = [];
        let purposes = [];

        if (fileLogo != null) {
          this.jumlahFile += 1;
          files.push(fileLogo);
          purposes.push("kontraktor");
        }
        if (fileDokumenPengesahan != null) {
          this.jumlahFile += 1;
          files.push(fileDokumenPengesahan);
          purposes.push("pengesahan");
        }
        if (fileDokumenIUJP != null) {
          this.jumlahFile += 1;
          files.push(fileDokumenIUJP);
          purposes.push("iujp");
        }
        if (fileDokumenNIB != null) {
          this.jumlahFile += 1;
          files.push(fileDokumenNIB);
          purposes.push("nib");
        }

        this.simpanEditProfile(files, purposes);
      }
    },
    validasiForm() {
      let status = true;
      let kolom = [];
      if (this.formValues.namaKontraktor.trim() == "") {
        status = status && false;
        kolom.push("Nama Kontraktor");
      }
      if (this.formValues.klasifikasi == "") {
        status = status && false;
        kolom.push("Klasifikasi");
      }
      if (
        this.formValues.kualifikasiUsaha == "" ||
        this.formValues.kualifikasiUsaha == null
      ) {
        status = status && false;
        kolom.push("Kualifikasi Usaha");
      }
      if (this.formValues.nomorNIB.trim() == "") {
        status = status && false;
        kolom.push("Nomor NIB");
      }
      if (
        this.$refs.fileDokumenNIB.value == "" &&
        (this.kontraktor.fileNib == null || this.kontraktor.fileNib == "")
      ) {
        status = status && false;
        kolom.push("File Dokumen NIB");
      } else if (
        this.$refs.fileDokumenNIB.value == "" &&
        this.count_kbli_previous != this.formValues.kblis.length
      ) {
        status = status && false;
        kolom.push("File Dokumen NIB harus diperbarui");
      }
      if (this.wajibIUJP == true) {
        if (this.formValues.nomorIUJP.trim() == "") {
          status = status && false;
          kolom.push("Nomor IUJP");
        }
        if (
          this.formValues.masaBerlakuIUJP == "" ||
          this.formValues.masaBerlakuIUJP == null
        ) {
          status = status && false;
          kolom.push("Masa Berlaku IUJP");
        }
        if (
          this.$refs.fileDokumenIUJP.value == "" &&
          (this.kontraktor.fileIujp == null || this.kontraktor.fileIujp == "")
        ) {
          status = status && false;
          kolom.push("File Dokumen IUJP");
        } else if (
          this.$refs.fileDokumenIUJP.value == "" &&
          this.count_bidangs_previous != this.formValues.bidangs.length
        ) {
          status = status && false;
          kolom.push("File Dokumen IUJP harus diperbarui");
        }
      }
      return [status, kolom];
    },
    validasiFormKBLIs() {
      let status = true;
      let kolom = [];
      // for (let h in this.formValues.kblis) {
      //   let current = this.formValues.kblis[h]

      //   if(current.tingkatResiko == "" || current.tingkatResiko == null){
      //     status = status && false
      //     let i = parseInt(h) + 1
      //     kolom.push('Tingkat Resiko form KBLI ke-'+ i)
      //   }
      // }
      if (this.formValues.kblis.length == 0) {
        status = status && false;
        kolom.push("KBLI perlu ditambahkan");
      }
      this.formValues.kblis.forEach((item, index) => {
        if (item.tingkatResiko == "" || item.tingkatResiko == null) {
          status = status && false;
          kolom.push("Tingkat Resiko form KBLI ke-" + (index + 1));
        }
      });
      return [status, kolom];
    },
    validasiFileKBLIs() {
      let status = true;
      let kolom = [];
      // let ret = false;
      // console.log('dt ', this.upload_kblis);
      // for (var h in this.upload_kblis) {
      //   let uk = this.upload_kblis[h] //id,index,req_sertifikasi,req_izin
      //   if (uk.req_izin && this.formValues.kblis[h].fileIzin == null) {
      //     // console.log(this.$refs.FileDokumenIzin[uk.index].value)
      //     if (this.$refs.FileDokumenIzin[uk.index].value == "") {
      //       status = status && false
      //       let i = parseInt(h) + 1
      //       kolom.push('File Dokumen Izin form KBLI ke-' + i)
      //     }
      //   }

      //   if (uk.req_sertifikasi && this.formValues.kblis[h].fileSertifikat == null) {
      //     // console.log(this.$refs.FileDokumenSertifikasi[uk.index].value)
      //     if (this.$refs.FileDokumenSertifikasi[uk.index].value == "") {
      //       status = status && false
      //       let i = parseInt(h) + 1
      //       kolom.push('File Dokumen Sertifikasi form KBLI ke-' + i)
      //     }
      //   }
      // }
      this.formValues.kblis.forEach((item, index) => {
        console.log(item);
        if (
          this.$refs.FileDokumenSertifikasi[index].value == "" &&
          (item.tingkatResiko == 2 || item.tingkatResiko == 3) &&
          (item.fileSertifikat == null || item.fileSertifikat == "")
        ) {
          status = status && false;
          kolom.push("File Dokumen Sertifikat form KBLI ke-" + (index + 1));
        }
        if (
          this.$refs.FileDokumenIzin[index].value == "" &&
          item.tingkatResiko == 4 &&
          (item.fileIzin == null || item.fileIzin == "")
        ) {
          status = status && false;
          kolom.push("File Dokumen Izin form KBLI ke-" + (index + 1));
        }
      });
      return [status, kolom];
    },
    validasiBidangIUJP() {
      let status = true;
      let kolom = [];
      if (this.wajibIUJP == true) {
        console.log(this.formValues.bidangs);
        if (this.formValues.bidangs.length == 0) {
          status = status && false;
          kolom.push("Bidang Dan Sub Bidang perlu ditambahkan");
        } else {
          this.formValues.bidangs.forEach((item, index) => {
            if (item.NMBIDANG == "") {
              status = status && false;
              kolom.push(`Bidang form Bidang IUJP ke-${index + 1}`);
            }
            if (item.SUBBIDANG == "") {
              status = status && false;
              kolom.push(`Sub Bidang form Bidang IUJP ke-${index + 1}`);
            }
          });
        }
      }
      return [status, kolom];
    },
    compareKBLIS() {
      this.final_kblis = [];
      this.upload_kblis = [];
      this.added_kblis = [];
      // console.log('current : ',this.formValues.kblis);
      // console.log('old : ',this.temp_kblis);
      for (var z in this.formValues.kblis) {
        let current = this.formValues.kblis[z];
        let pushed = null;
        let pusUpload = null;
        let added = null;
        // let trs = current.tingkatResiko
        if (current.id == null) {
          // if added
          pushed = {
            kontraktorId: this.$route.params.id,
            kode: current.kode,
            deskripsi: current.deskripsi,
            izin: current.izin == "-" ? null : current.izin,
            sertifikasiStandar:
              current.sertifikasiStandar == "-"
                ? null
                : current.sertifikasiStandar,
            tingkatResiko: current.tingkatResiko,
            // tingkatResikoStr: trs != "" ? this.tingkatResiko[trs - 1].label : "",
          };
          added = {
            kode: current.kode,
            deskripsi: current.deskripsi,
            izin: current.izin == "-" ? null : current.izin,
            sertifikasiStandar:
              current.sertifikasiStandar == "-"
                ? null
                : current.sertifikasiStandar,
            tingkatResiko: current.tingkatResiko,
            // tingkatResikoStr: trs != "" ? this.tingkatResiko[trs - 1].label : "",
            req_izin: current.tingkatResiko == 4 ? true : false,
            req_sertifikasi: false,
            // current.tingkatResiko == 2 ||
            // current.tingkatResiko == 3 ||
            // current.tingkatResiko == 4
            //     ? true
            //     : false,
          };
        }
        if (pushed != null) {
          this.final_kblis.push(pushed);
          // continue;
        }

        if (added != null) {
          this.added_kblis.push(added);
          // continue;
        }

        for (var x in this.temp_kblis) {
          let old = this.temp_kblis[x];
          if (old.id == current.id) {
            if (
              old.kode != current.kode ||
              old.deskripsi != current.deskripsi ||
              old.tingkatResiko != current.tingkatResiko
            ) {
              // if edited
              if (current.show == true && current.id !== undefined) {
                // if not deleted
                pushed = {
                  id: current.id,
                  kontraktorId: this.$route.params.id,
                  kode: current.kode,
                  deskripsi: current.deskripsi,
                  izin: null,
                  sertifikasiStandar: null,
                  tingkatResiko: current.tingkatResiko,
                  // tingkatResikoStr:
                  //     trs != null ? this.tingkatResiko[trs - 1].label : "",
                  isDeleted: false,
                };
                if (pushed != null) {
                  this.final_kblis.push(pushed);
                  // continue;
                }
              }
            }

            // if(current.deleted==false){
            let req_sertifikasi = false;
            let req_izin = false;
            if (current.tingkatResiko != null) {
              // if (current.tingkatResiko == 2 || current.tingkatResiko == 3) {
              //     req_sertifikasi = true
              //     req_izin = false
              // } else
              if (current.tingkatResiko == 4) {
                req_sertifikasi = false;
                req_izin = true;
              }
            }
            // console.log(current.id, ' ', req_izin, ' ', req_sertifikasi)
            pusUpload = {
              id: current.id,
              index: z,
              req_sertifikasi: req_sertifikasi,
              req_izin: req_izin,
            };
            // }
            if (pusUpload != null && current.id != null) {
              this.upload_kblis.push(pusUpload);
              break;
            }
          }
        }
      }

      for (var j in this.deleted_kblis) {
        //loop deleted
        let del = this.deleted_kblis[j];
        // let trs = del.tingkatResiko
        let pushed = {
          id: del.id,
          kontraktorId: this.$route.params.id,
          kode: del.kode,
          deskripsi: del.deskripsi,
          izin: del.izin == "-" ? null : del.izin,
          sertifikasiStandar:
            del.sertifikasiStandar == "-" ? null : del.sertifikasiStandar,
          tingkatResiko: del.tingkatResiko,
          // tingkatResikoStr: trs != null ? this.tingkatResiko[trs - 1].label : "",
          isDeleted: true,
        };
        this.final_kblis.push(pushed);
      }

      // console.log('deleted:',this.deleted_kblis)
      // console.log('final: ',this.final_kblis);
      // console.log('upload: ',this.upload_kblis);
      // console.log('added: ', this.added_kblis);
      // return this.final_kblis;
    },
    alertSukses() {
      Swal.fire({
        title: "Edit Profile Sukses",
        text: "Data Profile Perusahaan telah diperbarui!",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        this.$router.back();
      });
    },
    handleChangeFile(refFile) {
      let file = null;
      if (refFile == "nib") {
        file = this.$refs.fileDokumenNIB.files[0];
      } else if (refFile == "iujp") {
        file = this.$refs.fileDokumenIUJP.files[0];
      } else if (refFile == "suratPengesahan") {
        file = this.$refs.fileDokumenPengesahan.files[0];
      }

      if (file) {
        // Check file type
        if (file.type !== "application/pdf") {
          if (refFile == "nib") {
            this.validasiFile.typeNib = true;
            this.validasiFile.sizeNib = false;
            this.$refs.fileDokumenNIB.value = "";
          } else if (refFile == "iujp") {
            this.validasiFile.typeIujp = true;
            this.validasiFile.sizeIujp = false;
            this.$refs.fileDokumenIUJP.value = "";
          } else if (refFile == "suratPengesahan") {
            this.validasiFile.typeSuratPengesahan = true;
            this.validasiFile.sizeSuratPengesahan = false;
            this.$refs.fileDokumenPengesahan.value = "";
          }
          return;
        }

        // Check file size ({{max_file_size}}MB limit)
        if (file.size > max_file_size * 1024 * 1024) {
          if (refFile == "nib") {
            this.validasiFile.typeNib = false;
            this.validasiFile.sizeNib = true;
            this.$refs.fileDokumenNIB.value = "";
          } else if (refFile == "iujp") {
            this.validasiFile.typeIujp = false;
            this.validasiFile.sizeIujp = true;
            this.$refs.fileDokumenIUJP.value = "";
          } else if (refFile == "suratPengesahan") {
            this.validasiFile.typeSuratPengesahan = false;
            this.validasiFile.sizeSuratPengesahan = true;
            this.$refs.fileDokumenPengesahan.value = "";
          }
          return;
        }

        // Reset error messages if the file is valid
        if (refFile == "nib") {
          this.validasiFile.typeNib = false;
          this.validasiFile.sizeNib = false;
        } else if (refFile == "iujp") {
          this.validasiFile.typeIujp = false;
          this.validasiFile.sizeIujp = false;
        } else if (refFile == "suratPengesahan") {
          this.validasiFile.typeSuratPengesahan = false;
          this.validasiFile.sizeSuratPengesahan = false;
        }

        // Handle the valid file as needed (e.g., store the file)
        // console.log('Valid file:', file);
      }
    },
    handleChangeFileKBLI(index, refFile) {
      console.log("w", refFile);
      console.log("x", index);
      console.log("y", this.formValues.kblis);
      console.log("fdi:", this.$refs.FileDokumenIzin[index]);

      let file = null;
      if (refFile == "sertifikasi") {
        if (this.$refs.FileDokumenSertifikasi[index] != null) {
          file = this.$refs.FileDokumenSertifikasi[index].files[0];
        }
      } else if (refFile == "izin") {
        if (this.$refs.FileDokumenIzin[index] != null) {
          file = this.$refs.FileDokumenIzin[index].files[0];
        }
      }
      console.log("file:", file);
      // console.log(this.$refs.FileDokumenSertifikasi[index]);
      // console.log(this.$refs.FileDokumenSertifikasi[index].files[0]);
      // console.log(file);
      // alert(index);
      // alert(JSON.stringify(this.$refs.FileDokumenSertifikasi[index]));
      if (file) {
        if (file.type !== "application/pdf") {
          if (refFile == "sertifikasi") {
            this.formValues.kblis[index].typeSertifikasi = true;
            this.formValues.kblis[index].sizeSertifikasi = false;
          } else if (refFile == "izin") {
            this.formValues.kblis[index].typeIzin = true;
            this.formValues.kblis[index].sizeIzin = false;
          }
          return;
        }
        if (file.size > max_file_size * 1024 * 1024) {
          if (refFile == "sertifikasi") {
            this.formValues.kblis[index].typeSertifikasi = false;
            this.formValues.kblis[index].sizeSertifikasi = true;
          } else if (refFile == "izin") {
            this.formValues.kblis[index].typeIzin = false;
            this.formValues.kblis[index].sizeIzin = true;
          }
          return;
        }

        if (refFile == "sertifikasi") {
          this.formValues.kblis[index].typeSertifikasi = false;
          this.formValues.kblis[index].sizeSertifikasi = false;
        } else if (refFile == "izin") {
          this.formValues.kblis[index].typeIzin = false;
          this.formValues.kblis[index].sizeIzin = false;
        }
      }
      // console.log(this.formValues.kblis[index]);
      // console.log(this.formValues.kblis)
    },
    downloadFile(filename) {
      //   axios.get(url_download+filename)
      //   .then(()=>{

      //   });
      window.open(url_download + filename, "_blank");
    },
  },
};
</script>
